export enum WatermarkField {
  user_mark = 'user_mark',
  group_id = 'group_id',
  client_ip = 'client_ip',
  mac = 'mac',
  ctime = 'ctime',
  custom_text = 'custom_text',
}

export enum WatermarkFieldSlot {
  user_mark = 0,
  group_id,
  client_ip,
  mac,
  ctime,
  custom_text,
}
